var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kiosk-spinner",attrs:{"aria-hidden":"true"}},_vm._l((12),function(bar){return _c('span',{key:bar,staticClass:"kiosk-spinner-bar"})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }